export default __webpack_public_path__ + "static/media/musical.1154923f.mp3";